module.exports = __webpack_public_path__ + "cement/img/蒙版组 274@2x.7bbe1406.png";